import React, { useState, useEffect } from 'react';
import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  Typography,
  FormControl,
  InputLabel,
  CircularProgress
} from '@mui/material';

function FileSelectBox({ 
  shareFileList = [],
  onFileSelect, 
  selectedFileNames = [],
  disabled = false,
  className
}) {
  const [selectedFiles, setSelectedFiles] = useState(selectedFileNames);
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // 親コンポーネントからの選択状態を反映
  useEffect(() => {
    setSelectedFiles(selectedFileNames);
  }, [selectedFileNames]);

  // 親コンポーネントからの選択状態を反映
  useEffect(() => {
      console.log('selectedFileNames prop changed:', selectedFileNames);
      // 配列であることを確認
      if (Array.isArray(selectedFileNames)) {
          setSelectedFiles(selectedFileNames);
      } else {
          setSelectedFiles([]); // 配列でない場合は空配列
      }
  }, [selectedFileNames]);

  const handleChange = (event) => {
      try {
          const newSelection = event.target.value;
          console.log('selection changed to:', newSelection);
          
          // 配列であることを確認
          const selectionArray = Array.isArray(newSelection) ? newSelection : [];
          
          setSelectedFiles(selectionArray);
          setError(null);
          
          // 親コンポーネントに通知
          if (onFileSelect) {
              const selectedFileObjects = selectionArray.map(fileName => {
                  const fileData = files.find(file => file.name === fileName);
                  return {
                      name: fileName,
                      size: fileData?.size || '',
                      timestamp: fileData?.timestamp || ''
                  };
              });
              
              onFileSelect(selectedFileObjects);
          }
      } catch (err) {
          console.error('FileSelectBox error:', err);
          setError('ファイル選択中にエラーが発生しました');
      }
  };

  return (
    <Box sx={{ width: '100%', minWidth: 400, p: 2 }} className={className}>
      {error && (
        <Typography color="error" variant="body2" sx={{ mb: 1 }}>
          {error}
        </Typography>
      )}
  
      <FormControl fullWidth sx={{ width: '60%' }}>
        <InputLabel 
          id="file-select-label"
          sx={{
            color: disabled ? 'rgba(0, 0, 0, 0.38)' : undefined,
            '&.Mui-disabled': {
              color: 'rgba(0, 0, 0, 0.38)'
            }
          }}
        >
          ファイルを選択
        </InputLabel>
        <Select
          labelId="file-select-label"
          multiple
          value={selectedFiles || []}
          onChange={handleChange}
          disabled={disabled || loading} // ローディング中も無効化
          renderValue={(selected) =>
            loading 
              ? 'ファイル一覧を取得中...' 
              : selected.length === 0 
                ? 'ファイルを選択してください' 
                : `${selected.length}個のファイルを選択`
          }
          displayEmpty
          sx={{
            '&.Mui-disabled': {
              color: 'rgba(0, 0, 0, 0.38)',
              '& .MuiSelect-select': {
                color: 'rgba(0, 0, 0, 0.38)'
              }
            }
          }}
        >
          {loading ? (
            // ローディング中の表示
            <MenuItem disabled>
              <Box display="flex" alignItems="center" justifyContent="center" width="100%" py={2}>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                <Typography variant="body2">ファイル一覧を取得中...</Typography>
              </Box>
            </MenuItem>
          ) : (
            // 通常のファイル一覧表示
            shareFileList.map((file) => (
              <MenuItem key={file.name} value={file.name}>
                <Checkbox 
                  checked={selectedFiles.includes(file.name)} 
                  size="small"
                  disabled={disabled}
                />
                <ListItemText 
                  primary={file.name}
                />
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </Box>
  );  
}

export default FileSelectBox;
